/* Zeus pre-order label.
 *
 * Relabels the Add to cart button and puts a short note under it, for the
 * VARIANTS that are actually pre-order - not the whole product. zeus-preorder.liquid
 * emits a variant-id -> boolean map; this reads the currently selected id and
 * switches as the customer clicks between combinations.
 *
 * Both directions matter. Switching from a pre-order variant back to a stocked
 * one has to restore "Add to cart" and drop the note, or a machine sitting in
 * the warehouse keeps telling people to wait for it.
 *
 * Dawn replaces the product-form markup on a variant change, which wipes what we
 * inject - so this re-applies after each change. It also watches the button's
 * own subtree, because Dawn rewrites the label when availability changes and
 * would otherwise undo us a moment later.
 */
(() => {
  const el = document.getElementById('zeus-preorder-data');
  if (!el) return;
  let data;
  try {
    data = JSON.parse(el.textContent);
  } catch {
    return;
  }
  const LABEL = String(data?.label || 'Pre-order').trim();
  const NOTE = String(data?.note || '').trim();
  if (!LABEL) return;

  const preIds = new Set(
    Object.entries(data?.variants || {})
      .filter(([, isPre]) => isPre === true)
      .map(([id]) => String(id))
  );
  if (!preIds.size) return;            // opted in, but nothing is on pre-order

  const buttons = () => [...document.querySelectorAll('.product-form__submit[name="add"]')];

  const selectedId = () => {
    const input = document.querySelector(
      'product-form form [name="id"], form[action*="/cart/add"] [name="id"]'
    );
    const v = input && input.value;
    return v ? String(v) : null;
  };

  let applying = false;
  const apply = () => {
    if (applying) return;
    applying = true;

    const id = selectedId();
    const isPre = id ? preIds.has(id) : false;

    for (const btn of buttons()) {
      const span = btn.querySelector('span:not(.visually-hidden)') || btn.querySelector('span');
      if (!span) continue;

      // Remember Dawn's own wording so the stocked variants can be put back.
      const current = span.textContent.trim();
      if (!span.dataset.zeusOrig && current && current !== LABEL) span.dataset.zeusOrig = current;

      const form = btn.closest('product-form, .product-form') || btn.parentElement;
      const note = form && form.querySelector('.zeus-preorder__note');

      // A genuinely unavailable variant stays as Dawn rendered it. Pre-order is
      // about selling stock we do not have yet, not about overriding a variant
      // that cannot be bought at all.
      if (isPre && !btn.disabled) {
        if (current !== LABEL) span.textContent = LABEL;
        btn.classList.add('zeus-preorder__btn');
        if (NOTE && form && !note) {
          const p = document.createElement('p');
          p.className = 'zeus-preorder__note';
          p.textContent = NOTE;
          btn.insertAdjacentElement('afterend', p);
        }
      } else {
        if (current === LABEL && span.dataset.zeusOrig) span.textContent = span.dataset.zeusOrig;
        btn.classList.remove('zeus-preorder__btn');
        if (note) note.remove();
      }
    }
    applying = false;
  };

  // Dawn swaps the section markup out, so re-apply rather than holding a node.
  const section = document.querySelector('[data-section-id], section') || document;
  section.addEventListener('change', () => setTimeout(apply, 60), true);

  const mo = new MutationObserver(() => {
    if (!applying) apply();
  });
  const watch = () => {
    for (const btn of buttons()) mo.observe(btn, { childList: true, subtree: true, characterData: true });
  };

  apply();
  watch();
  setTimeout(() => {
    apply();
    watch();
  }, 400);
})();
